// extracted by mini-css-extract-plugin
export var active = "MenuBar-module--active--2ec76";
export var core = "MenuBar-module--core--f554e";
export var open = "MenuBar-module--open--03846";
export var openBtn = "MenuBar-module--open-btn--b4c07";
export var switchLanguage = "MenuBar-module--switchLanguage--b85d4";
export var visible = "MenuBar-module--visible--7c2fd";